<template>
  <div class="BoyoTable">
    <div ref="tableMode_one"
         class="tableMode_one">
      <el-table :data="tableInfo.data"
                ref="table"
                highlight-current-row
                :resizable="tableInfo.resizable?tableInfo.resizable:true"
                :border="tableInfo.resizable?tableInfo.resizable:true"
                :max-height="tableInfo.height?tableInfo.height:maxHeight"
                :row-key="tableInfo.key"
                :default-expand-all="tableInfo.expand"
                :tree-props="tableInfo.props"
                tooltip-effect="dark"
                :row-style="tableRowClassName"
                :header-cell-style="{background:'#eff3f8',color:'black','border-bottom':'1px solid #cccccc','font-size':'14px',padding:'2px 0'}"
                :cell-style="tableCellClassName"
                @row-dblclick="rowDblclick"
                @selection-change="handleSelectionChange"
                @select-all="selectChange"
                @row-click="rowClick"
                @cell-click="cellClick">
        <el-table-column v-if="tableInfo.selection"
                         type="selection" width="60"
                         fixed>
        </el-table-column>
        <!-- <el-table-column v-if="tableInfo.selection"
                         width="45"
                         fixed>
          <template slot="header">
            <input type="checkbox"
                   v-model="checkAll"
                   @change="checkAllClick">
          </template>
          <template slot-scope="scope">
            <input type="checkbox"
                   v-model="ckeckVal[scope.$index]"
                   @change="checkboxOnclick(scope.$index,scope.row)">
          </template>
        </el-table-column> -->
        <el-table-column v-if="tableInfo.selectionTwo"
                         type="selection"
                         :selectable="selected"
                         width="45"
                         fixed="left">
        </el-table-column>
        <el-table-column type="index" v-if="tableInfo.tagXu?false:true"
                         label="序"
                         width="60"
                         fixed="left">
        </el-table-column>
        <template v-for="item of tableInfo.fieldList">
          <el-table-column v-if="item.childBase"
                           :key="'desktop-' + item.value"
                           :label="item.label"
                           :align="item.align||'center'"
                           :sortable="item.sortable">
            <template v-for="item2 of item.childBase">
              <el-table-column :key="item2.value"
                            :label="item2.label"
                            :prop="item2.value"
                            :show-overflow-tooltip="item2.showOverflowTooltip !== undefined ? item2.showOverflowTooltip : (item2.type !== 'button')"
                            :width="item2.width"
                            :min-width="item2.minWidth"
                            :align="item2.align||'center'"
                            :fixed="item2.fixed"
                            :sortable="item2.sortable">
                <template slot-scope="scope">
                  <!-- 表格列自定义插槽 -->
                    <template v-if="item.label == '车牌号' && (scope.row.routerName == '预约打印' || scope.row.routerName == '车辆入厂' || scope.row.routerName == '采样确认' || scope.row.routerName == '过期审批' || scope.row.routerName == '异常审批' || scope.row.routerName == '检测结果')">
                      <span style="color:red">{{ scope.row[item2.value]}}</span>
                    </template>
                    <template v-else>
                      {{ scope.row[item2.value]}}
                    </template>
                </template>
              </el-table-column>
            </template>
          </el-table-column>
          <el-table-column v-else-if="item.show"
                           :key="'desktop-' + item.value"
                           :label="((item.label.indexOf('金额') != -1 && item.label.indexOf('元') == -1) || (item.label.indexOf('单价') != -1 && item.label.indexOf('株') != -1) || item.label.indexOf('余额') != -1 || item.label.indexOf('额度') != -1 || item.label.indexOf('税金') != -1 || item.label.indexOf('税额') != -1 || (item.label.indexOf('运费') != -1 && item.label.indexOf('运费合同') == -1 && item.label.indexOf('运费单号') == -1 && item.label.indexOf('区域') == -1) || item.label.indexOf('总应收款') != -1 || item.label.indexOf('税费合计') != -1 || item.label === '预收款') ? (item.label + '('+ amountUnit +')') : item.label"
                           :prop="item.value"
                           :show-overflow-tooltip="item.showOverflowTooltip !== undefined ? item.showOverflowTooltip : (item.type !== 'button')"
                           :width="item.width"
                           :min-width="item.minWidth"
                           :align="item.align||'center'"
                           :fixed="item.fixed"
                           :sortable="item.sortable ">
            <template slot-scope="scope">
              <!-- 表格列自定义插槽 -->
              <template v-if="item.type === 'slot'">
                <slot :name="'col-' + item.value"
                      :row="scope.row"
                      :index="scope.$index" />
              </template>
              <template v-else-if="item.type === 'switch'">
                <el-switch v-for="item of tableInfo.btList1"
                           v-model="scope.row.switch"
                           :key="item.event"
                           @change="changeSwitch(scope.$index, scope.row,item.event)">
                  <!-- <i :class="item.icon">{{item.label}}</i> -->
                </el-switch>
              </template>
              <template v-else-if="item.type === 'button'">
                <el-button v-for="e of tableInfo.btList"
                           :key="e.event"
                           :style="e.style"
                           size="mini"
                           @click="TableEvent(scope.$index, scope.row,e.event)">
                  <span :class="e.icon">{{e.label}}</span>
                </el-button>
              </template>
              <template v-else-if="item.type === 'buttonQx'">
                <el-button v-for="e of tableInfo.btList2"
                           :key="e.event"
                           :style="e.style"
                           size="mini"
                           @click="TableEvent(scope.$index, scope.row,e.event)">
                  <span :class="e.icon">{{e.label}}</span>
                </el-button>
              </template>
              <template v-else-if="item.list">
                {{getlistTypeInfo(scope.row[item.value],item.list)}}
              </template>
              <template v-else-if="item.label == '车牌号' && (scope.row.routerName == '预约打印' || scope.row.routerName == '车辆入厂' || scope.row.routerName == '采样确认' || scope.row.routerName == '过期审批' || scope.row.routerName == '异常审批' || scope.row.routerName == '检测结果')">
                <span style="color:red">{{ scope.row[item.value]}}</span>
              </template>
              <template v-else-if="(item.label.indexOf('数量') != -1 && item.label.indexOf('卸车数量') == -1) || item.label.indexOf('计划产量') != -1 || item.label.indexOf('送货量') != -1 || item.label.indexOf('重量') != -1 || item.label.indexOf('总扣杂') != -1 || item.label.indexOf('净重') != -1 || item.label.indexOf('金额') != -1 || item.label.indexOf('余额') != -1 || item.label.indexOf('额度') != -1 || item.label.indexOf('税金') != -1 || item.label.indexOf('税额') != -1 || (item.label.indexOf('运费') != -1 && item.label.indexOf('运费合同') == -1 && item.label.indexOf('运费单号') == -1 && item.label.indexOf('区域') == -1) || item.label.indexOf('总应收款') != -1 || item.label.indexOf('税费合计') != -1 || item.label === '预收款'">
                {{ formatAmount(scope.row[item.value])}}
              </template>
              <template v-else>
                {{ scope.row[item.value]}}
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <table border="1"
           ref="tableMode_two"
           class="tableMode_two">
      <tr v-for="(data,index) of tableInfo.data"
          :key="'data-row-' + index">
        <td class="td">
          <div style="width:100%"
               v-if="tableInfo.selection">
            <input type="checkbox"
                   v-model="ckeckVal[index]"
                   @change="checkboxOnclick(index,data)">
          </div>
          <div v-for="item of tableInfo.fieldList"
               :key="'mobile-' + item.value">
            <div v-if="item.show==='true'">
              <span class="title">{{item.label}}</span>
              <!-- <span v-if="item.type==='switch'">
                <el-switch v-model="value"
                           active-color="#13ce66"
                           inactive-color="#ff4949"
                           @click="changeSwitch (index, data, event)">
                </el-switch>
              </span> -->
              <span v-if="item.type==='button'">
                <el-button v-for="item of tableInfo.btList"
                           :key="item.event"
                           :style="item.style"
                           size="mini"
                           @click="TableEvent(index, data,item.event)">
                  <i :class="item.icon">{{item.label}}</i>
                </el-button>
              </span>
              <span v-else-if="item.type==='slot'">
                <slot :name="'col-' + item.value"
                      :row="data"
                      :index="index" />
              </span>
              <span v-else-if="item.list">
                {{getlistTypeInfo(data[item.value],item.list)}}
              </span>
              <el-tooltip v-else-if="item.type==='over'"
                          effect="dark"
                          :content="''+data[item.value]"
                          placement="top">
                <el-button style="background:none;padding:0;color:#676a6c;font-size:13px;cursor:auto">
                  <span class="item">{{data[item.value]}}</span>
                </el-button>
              </el-tooltip>
              <span class="item"
                    :title="data[item.value]"
                    v-else>{{data[item.value]}}</span>
            </div>
          </div>
        </td>
      </tr>
    </table>
    <el-pagination v-if="tableInfo.pager"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   background
                   :small="true"
                   :key="`${filterInfo && filterInfo.pageNumber}-${filterInfo && filterInfo.pageSize}`"
                   style="margin-top:10px"
                   :current-page="Number(filterInfo.pageNumber)"
                   :page-sizes="[10, 20, 30, 50, 80, 100, 200]"
                   :page-size="filterInfo.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="tableInfo.total">
    </el-pagination>
    <el-pagination v-if="tableInfo.pagerTwo"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   background
                   :small="true"
                   :key="`${filterInfo && filterInfo.pageNumber}-${filterInfo && filterInfo.pageSize}`"
                   style="margin-top:10px"
                   :current-page="Number(filterInfo.pageNumber)"
                   :page-sizes="[10, 20, 30, 50, 80, 100, 200]"
                   :page-size="filterInfo.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="tableInfo.total">
    </el-pagination>
    <div v-if="!tableInfo.pager && !tableInfo.showSum1"
         v-show="!tableInfo.accessShow"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      共{{tableInfo.total}}条记录。
    </div>
    <div v-if="tableInfo.showNum2"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      共{{tableInfo.total}}条记录,合计平方数{{tableInfo.selectListData.squareNumbers}},合计体积{{tableInfo.selectListData.volume}}。
    </div>
    <div v-if="tableInfo.showNum3"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      共{{tableInfo.total}}条记录,合计单面积{{tableInfo.selectListData.squareNumbers}}。
    </div>
    <div v-if="tableInfo.showNum"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      共{{tableInfo.total}}条记录,合计扣杂{{tableInfo.sumData.sumImpurities}},合计净重量{{tableInfo.sumData.sumnetWeigh}},合计实重{{tableInfo.sumData.sumweight}},合计金额{{tableInfo.sumData.price}},合计整单扣额{{tableInfo.sumData.sumpriceAdjust}},合计实付金额{{tableInfo.sumData.sumpayAdjust}}。
    </div>
    <div v-if="tableInfo.showSum"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      共{{tableInfo.total}}条记录
      ,合计净重量{{tableInfo.sumData.sumnetWeigh}},合计扣杂{{tableInfo.sumData.sumImpurities}},合计实重{{tableInfo.sumData.sumweight}}。
      <!-- ,合计车数{{tableInfo.sumData.sumcountShipCar}}。 -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'BoyoTable',
  props: {
    tableInfo: Object,
    filterInfo: Object,
    listTypeInfo: Object
  },
  data () {
    return {
      // mark: true,
      checkboxList: [],
      ckeckVal: [],
      checkAll: false,
      maxHeight:null,
      empList:[],
      amountUnit:localStorage.amountUnit?localStorage.amountUnit:'元',
    }
  },
  watch: {
    'tableInfo.mode' (val) {
      let screenWidth = document.body.clientWidth
      if (screenWidth <= 960) {
        this.$refs.tableMode_one.style.cssText = this.$refs.tableMode_one.style.display === 'block' ? 'display:none' : 'display: block'
        this.$refs.tableMode_two.style.cssText = this.$refs.tableMode_two.style.display === 'none' ? 'display: table' : 'display: none'
      } else {
        this.$refs.tableMode_one.style.cssText = this.$refs.tableMode_one.style.display === 'none' ? 'display:block' : 'display: none'
        this.$refs.tableMode_two.style.cssText = this.$refs.tableMode_two.style.display === 'table' ? 'display: none' : 'display: table'
      }
      this.$refs.tableMode_two.style.width = '100%'
    },
    'tableInfo.selectReset' (val) {
      this.checkboxList = []
      this.ckeckVal = []
      this.checkAll = false
      this.$emit('handleSelectionChange', this.checkboxList)
    },
    'tableInfo.selectcancel' (val) {
      // this.checkboxList = []
      this.checkboxList = this.checkboxList.splice(val.length-1,1)
      this.ckeckVal = []
      this.checkAll = false
      this.$emit('handleSelectionChange', this.checkboxList)
    }
  },
  mounted () {
    // console.log(this.ckeckVal);
    this.$emit('update:refObj', this.$refs.table)
    // console.log(document.body.clientHeight, this.$refs.table.$el.offsetTop)
    // 表格自适应高度
    if(document.body.clientHeight){// && this.$refs.table.$el.offsetTop，totalHeightBot（底部有合计以及头部自定义按钮高度和）
      this.maxHeight = document.body.clientHeight - (this.tableInfo.totalHeightBot ? Number(this.tableInfo.totalHeightBot) : 0) - this.$refs.table.$el.offsetTop - 201 + 'px'
      // console.log(this.maxHeight)
    }else{
      this.maxHeight = '500px'
    }
  },
  methods: {
    formatAmount(cellValue) {
      if (typeof cellValue == 'number') {
        cellValue = Number(cellValue.toFixed(2))
        return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    getlistTypeInfo (val, list) {
      for (let i in this.listTypeInfo[list]) {
        if (val === this.listTypeInfo[list][i].value) {
          return this.listTypeInfo[list][i].label
        }
      }
    },
    // 原生checkbox事件
    checkboxOnclick (index, data) {
      let ckeckVal = this.ckeckVal
      const arr = JSON.parse(JSON.stringify(this.checkboxList))
      if (ckeckVal[index]) {
        this.checkboxList.push(data)
      } else {
        for (let i in this.checkboxList) {
          if (this.checkboxList[i].id === data.id) {
            arr.splice(i, 1)
            break
          }
        }
        this.checkboxList = arr
      }
      if (this.checkboxList.length === this.tableInfo.data.length) {
        this.checkAll = true
      } else if (this.checkboxList.length === 0) {
        this.checkAll = false
      }
      this.$emit('handleSelectionChange', this.checkboxList)
    },
    // 全选
    checkAllClick () {
      let checkAll = this.checkAll
      let ckeckVal = this.ckeckVal
      let data = this.tableInfo.data
      if (checkAll) {
        for (let i in data) {
          ckeckVal[i] = true
        }
        this.checkboxList = data
      } else {
        for (let i in data) {
          ckeckVal[i] = false
        }
        this.checkboxList = []
      }
      this.$emit('handleSelectionChange', this.checkboxList)
    },
    // 表格单选框事件
    handleSelectionChange (val) {
      this.$emit('handleSelectionChange', val)
    },
    selectChange (val) {
      this.$emit('selectChange', val)
    },
    tableRowClassName({row, rowIndex}){//背景色
        // console.log({row, rowIndex})
      if (row.tMatching) {
        if (Number(row.tMatching)>0) {
          return {
            background: '#f5f9f2'
          }
        }
      }
      if (row.accessFlag) {
        if (Number(row.accessFlag) == 1) {
          return {
            color: '#ff0000 !important'
          }
        }
        if (Number(row.accessFlag) == 2 && (row.accessArriveLoadometerName != row.accessLeaveLoadometerName || row.accessArriveFlag == 1 || row.accessLeaveFlag == 1)) {
          return {
            color: 'blue !important'
          }
        }
      }
      if ((row.isRange == 1 && row.routerName == '称重记录') || row.modificationFlag) {
        return {
          color: 'red'
        }
      }
      if (row.billDateStr && row.materialName && row.materialName.indexOf('合计') != -1) {
        return {
          background: '#c7ecf5'
        }
      }
      if (row.isLoad && row.selectFlag) {
        return {
          color: 'red'
        }
      }
      // if (Number(row.tMatching) != 0) {
      //   console.log({row, rowIndex})
      // }
      // this.$emit('tableRowClassName', row, rowIndex)
    },
    tableCellClassName({row, column, rowIndex, columnIndex}){//背景色
      // 订单有效期变色逻辑
      if (row.contractDeliveryEndDate) {
        const endDate = new Date(row.contractDeliveryEndDate);
        const currentDate = new Date();
        const remainingDays = Math.floor((endDate - currentDate) / 86400000);
        if (remainingDays <= 5 && remainingDays >= 0) {
          return {
            padding: '4px',
            'border-left': '1px solid #ccc',
            color: '#F56C6C !important'
          }
        } else if (remainingDays <= 15 && remainingDays >= 0) {
          return {
            padding: '4px',
            'border-left': '1px solid #ccc',
            color: '#E6A23C !important'
          }
        }
      }
      // 身份证到期变色
      if (row.idCardEndDate) {
  const endDate = new Date(row.idCardEndDate);
  const currentDate = new Date();
  const remainingDays = Math.floor((endDate - currentDate) / 86400000);
  
  // 如果已经过期
  if (remainingDays < 0) {
    return {
      padding: '4px',
      'border-left': '1px solid #ccc',
      color: '#F56C6C !important',
      'font-weight': 'bold'
    }
  } 
  // 如果30天内到期
  else if (remainingDays <= 30 && remainingDays >= 0) {
    return {
      padding: '4px',
      'border-left': '1px solid #ccc',
      color: '#E6A23C !important',
      'font-weight': 'bold'
    }
  }
}
      if (column.label == '车牌号' && row.routerName && (row.routerName == '预约打印' || row.routerName == '车辆入厂' || row.routerName == '采样确认' || scope.row.routerName == '检测结果')) {
        return {
          padding: '4px',
          'border-left': '1px solid #ccc',
          color: 'red'
        }
      } else if ((row.salReviewFlag && row.salReviewFlag == 2 && column.label == '销售分管') || (row.purReviewFlag && row.purReviewFlag == 2 && column.label == '采购分管') || (row.curStateName && row.curStateName.indexOf('不通过') != -1 && column.label == '当前状态')) {
        return {
          padding: '4px',
          'border-left': '1px solid #ccc',
          color: 'red'
        }
      } else if (row.routerName == '价格执行表审批' && ((column.label == '审核状态' && row.auditFlag == 2) || (column.label == '采购审核状态' && row.purReviewFlag == 2) || (column.label == '财务审核状态' && row.finReviewFlag == 2) || (column.label == '财务经理审核状态' && row.finConfirmFlag == 2) || (column.label == '总经办审核状态' && row.hrReviewFlag == 2))) {
        return {
          padding: '4px',
          'border-left': '1px solid #ccc',
          color: 'red'
        }
      } else if (row.routerName == '采购合同审核' && ((column.label == '一审状态' && row.auditFlag == 2) || (column.label == '二审状态' && row.finReviewFlag == 2) || (column.label == '三审状态' && row.hrReviewFlag == 2))) {
        return {
          padding: '4px',
          'border-left': '1px solid #ccc',
          color: 'red'
        }
      } else if (column.label == '是否上传合同' && row.freeItem2Flag == 0 && row.routerName == '采购正式合同') {
        return {
          padding: '4px',
          'border-left': '1px solid #ccc',
          color: 'red'
        }
      } else{
        return {
            padding: '4px',
            'border-left': '1px solid #ccc',
          }
      }
    },
    // 表格行单击事件
    rowClick (row) {
      this.$emit('TableEvent', 'null', row, 'rowClick')
    },
    // 表格行双击事件
    rowDblclick (row, column, event) {
      this.$emit('TableEvent', row, column, 'rowDblclick')
    },
    cellClick (row, column, cell, event) { // 单元格单击
      this.$emit('TableCellEvent', row, column, 'cellClick')
    },
    // 表格内部按钮事件
    changeSwitch (index, row, event) {
      this.$emit('changeSwitch', index, row, event)
    },
    TableEvent (index, row, event) {
      this.$emit('TableEvent', index, row, event)
    },
    handleSizeChange (pageSize) {
      this.$emit('handleSizeChange', pageSize)
    },
    handleCurrentChange (pageNumber) {
      this.$emit('handleCurrentChange', pageNumber)
    },
    getGoodSelect(row){
      // console.log(11,this.$refs.table.toggleRowSelection(row))
      this.$refs.table.clearSelection()
    },
    selected(row, index) {
      // console.log(row, index)
      if (Number(row.selectFlag) == 1) {
        return false //不可勾选
      } else {
        return true //可勾选
      }
    },
  }
}
</script>
<style lang="stylus" scoped>
.td
  border 1px dashed #000
</style>  



// WEBPACK FOOTER //
// src/components/BoyoTable/index.vue